// Stili e utilità condivisi dalle tabelle mensili V2 (Monthly Tracking e Monthly PM)
import { useLayoutEffect, useState } from 'react';

export const FIRST_COL = 220;
export const DAY_COL = 34;
export const WEEKEND_COL = 22;
export const TOTAL_COL = 62;
export const MIN_TABLE_HEIGHT = 320;

// Larghezza stimata del testo a 11.5px con cifre tabulari, più il margine della cella
const DIGIT_PX = 7;
const CELL_PADDING_PX = 12;
export const textWidth = (text) => {
  const str = String(text);
  const narrow = (str.match(/[.,]/g) || []).length;
  return (str.length - narrow) * DIGIT_PX + narrow * 3.5 + CELL_PADDING_PX;
};

export const BORDER = '1px solid var(--rt-grid-line)';
export const stickyLeft = { position: 'sticky', left: 0, zIndex: 2, bgcolor: 'background.paper', borderRight: '1px solid var(--rt-grid-border)' };
export const stickyRight = { position: 'sticky', right: 0, zIndex: 2, bgcolor: 'background.paper', borderLeft: '1px solid var(--rt-grid-border)' };
export const cellBase = { p: 0, height: 34, textAlign: 'center', fontSize: 11.5, fontVariantNumeric: 'tabular-nums', borderBottom: BORDER };
// Intestazione fissa in alto durante lo scroll verticale della tabella
export const stickyTop = { position: 'sticky', top: 0, zIndex: 3, borderBottom: '1px solid var(--rt-grid-border)', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' };
// Riga dei totali fissa in basso
export const stickyBottom = { position: 'sticky', bottom: 0, zIndex: 3, borderTop: '2px solid var(--rt-grid-border)', borderBottom: 'none', boxShadow: '0 -1px 2px rgba(0,0,0,0.06)' };

export const containerSx = (maxHeight) => ({
  border: '1px solid var(--rt-grid-border)',
  borderRadius: 2,
  bgcolor: 'background.paper',
  overflow: 'auto',
  // La tabella scorre al suo interno, così intestazione e totali restano visibili
  maxHeight: maxHeight ?? `max(${MIN_TABLE_HEIGHT}px, calc(100vh - 250px))`,
});

/**
 * Altezza massima = spazio tra l'inizio del contenitore e il fondo della finestra,
 * ricalcolata al resize e quando cambiano le dipendenze (es. filtri che vanno a capo).
 */
export function useFillViewportHeight(ref, deps) {
  const [maxHeight, setMaxHeight] = useState(null);
  useLayoutEffect(() => {
    const update = () => {
      const top = ref.current?.getBoundingClientRect().top;
      if (top !== undefined) setMaxHeight(Math.max(MIN_TABLE_HEIGHT, Math.floor(window.innerHeight - top - 16)));
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return maxHeight;
}
